module.exports = __webpack_public_path__ + "img/banner-2.777de69b.png";